import cn from 'classnames';
import React, { ReactNode } from 'react';

import s from './styles.module.css';

interface IProps {
  children: ReactNode;
  intent: 'danger' | 'warning';
  className?: string;
  dataTestId?: string;
}

const Banner = ({ children, intent, className, dataTestId }: IProps) => (
  <div className={cn(s.banner, s[intent], className)} role="alert" data-test-id={dataTestId}>
    {children}
  </div>
);

export { Banner };
